import type { ColumnMenuOption } from '@labrav/react-components'
import type {
  CloudMarketplace,
  Product,
} from '../../modules/productsListing/types'

export enum ExternalPlatformType {
  HUBSPOT = 'HUBSPOT',
  IMPARTNER = 'IMPARTNER',
}

export type SelectedProduct = {
  productId: string
  alertMessages?: object
}

export type ProductListingV2Props = {
  externalBaseURL?: string
  search?: string
  externalPlatformType?: ExternalPlatformType
}

export type CreateNewListingButtonProps = {
  isFreeTier: boolean | undefined
  enableToCreate: boolean
  selectedCloudTypeProductListing: CloudMarketplace
  externalBaseURL?: string | undefined
  externalPlatformType?: ExternalPlatformType
  productRows: Product[]
  loading: boolean
  handleCreateListingSelection: (option: ColumnMenuOption) => void
}

export type GetMenuOptionsArgs = {
  productRow: Product
  cloudProvider: CloudMarketplace
  externalBaseURL?: string
  search?: string
  externalPlatformType?: ExternalPlatformType
  cloud?: string
  accountId?: string
}

export const EMPTY_SELECTED_PRODUCT: SelectedProduct = {
  productId: '',
  alertMessages: {},
}
